<style>

</style>

<template>
  <table v-if="items.length > 0" class="table table-hover">
    <caption class="p-2">
      <slot name="caption">
        <template v-if="title">{{ title }} <span class="badge badge-dark">{{ grandQty }}</span></template>
      </slot>
    </caption>
    <colgroup>
      <col>
      <col>
      <col>
      <col>
    </colgroup>
    <thead>
    <tr>
      <th>Description</th>
      <th class="text-center">Price</th>
      <th class="text-center">Qty</th>
      <th class="text-right">Subtotal</th>
      <th v-if="editable">&nbsp;</th>
    </tr>
    </thead>

    <tfoot>
    <tr v-if="items.length">
      <td colspan="3" align="right"><b>Total:&nbsp;</b></td>
      <td class="text-right"><b>{{ grandTotal | money }}</b></td>
      <td v-if="editable">&nbsp;</td>
    </tr>
    </tfoot>

    <tbody>
    <tr v-for="item in items">
      <td>
        <figure class="d-flex">
          <a class="me-2" href="#" @click.prevent="onClick(item, $event)">
            <img class="rounded mr-3" width="80" :src="item.thumbnail" :alt="item.name"/>
          </a>
          <figcaption class="p-1 d-none d-md-block">
            <strong class="fs-6">
              <a href="#" @click.prevent="onClick(item, $event)">{{ item.name }}</a>
            </strong><br>
            <a href="#" @click.prevent="onClick(item, $event)">ID #{{ item.id }}</a>
          </figcaption>
        </figure>
      </td>

      <td class="text-center">
        {{ item.unitPrice | money }}
        <small v-if="item.listPrice && item.listPrice > item.unitPrice" class="text-muted"><s>{{
            item.listPrice | money
          }}</s></small>
      </td>
      <td class="text-center">
        {{ item.qty }}
      </td>
      <td class="text-right">{{ (item.qty * item.unitPrice) | money }}</td>

      <td v-if="editable">
        <a href="#" @click.prevent="onRemove(item, $event)" aria-label="Remove item">
          <i class="bi bi-x-lg"></i>
        </a>
      </td>
    </tr>
    </tbody>

  </table>
</template>

<script>
export default {
  props: {
    editable: false,
    title: String,
    items: Array,
    maps: {
      type: Object,
      default: function () {
        return {
          item: 'Item',
          price: 'Price',
          qty: 'Qty',
          total: 'Total',
          action: ''
        }
      }
    }
  },

  computed: {
    grandQty() {
      return this.items.reduce((total, item) => {
        return (item.qty) + total;
      }, 0);
    },

    grandTotal() {
      return this.items.reduce((total, item) => {
        return (item.unitPrice * item.qty) + total
      }, 0.0);
    }
  },


  data() {
    return {
      total: 0.0,
      cols: {}
    }
  },

  created() {
    this.$emit('update', this);
  },


  methods: {
    onClick(item, event) {
      this.$emit('click', item, event);
    },

    onRemove(item, event) {
      this.$emit('remove', item, event);
    }
  }
}
</script>